module.exports = __webpack_public_path__ + "static/img/4.94349d21.png";